import { Fragment, useRef } from "react";
import { ImportedAccountMappingCounts } from "@common/helpers/importedAccountMappingResolution";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import {
    isOverflowingX,
    useTruncationTooltip,
} from "@design-system/Tooltip/useTruncationTooltip";
import styles from "./CoaMappingDrawer.module.scss";

interface Props {
    importedCount: number;
    counts: ImportedAccountMappingCounts;
}

const buildAccountCountParts = (
    importedCount: number,
    counts: ImportedAccountMappingCounts,
) => {
    const parts = [
        `Imported accounts: ${importedCount}`,
        `Mapped accounts: ${counts.mapped}`,
        `New accounts: ${counts.newAccounts}`,
    ];
    if (counts.connectInTasks > 0) {
        parts.push(`Connect in tasks: ${counts.connectInTasks}`);
    }
    return parts;
};

export const CoaMappingCounts = ({ importedCount, counts }: Props) => {
    const textRef = useRef<HTMLDivElement>(null);
    const truncationTooltipProps = useTruncationTooltip({
        ref: textRef,
        isTruncated: isOverflowingX,
    });
    const countParts = buildAccountCountParts(importedCount, counts);

    return (
        <Tooltip content={countParts.join(" · ")} {...truncationTooltipProps}>
            <div ref={textRef} className={styles.accountCounts}>
                {countParts.map((part, index) => (
                    <Fragment key={part}>
                        {index > 0 && (
                            <span className={styles.countSeparator}>·</span>
                        )}
                        <span>{part}</span>
                    </Fragment>
                ))}
            </div>
        </Tooltip>
    );
};
